import { CianChatButtonWithAnimation } from '@cian/newbuilding-chat-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { onAnimationShown, onAnimationTooltipShown } from './analytics/analytics';
import { useChatAnimationCounter } from './hooks/useChatAnimationCounter';
import { getTooltipAnimationCookie, setTooltipAnimationCookie } from './utils/chatAnimationCounter';
import { customLabelSelector, isChatExistSelector, isLoadingSelector } from '../../selectors/consultantCianChat';

export const CianChatButtonWithAnimationContainer = ({ onClick }: { onClick(): void }) => {
  const trackingCustomLabel = useSelector(customLabelSelector);
  const isLoading = useSelector(isLoadingSelector);
  const isChatExist = useSelector(isChatExistSelector);

  const { incrementAnimationShownCounter, shouldShowAnimation, animationDelayMs } = useChatAnimationCounter();

  const [isTooltipAnimationVisible, setIsTooltipAnimationVisible] = React.useState(() => {
    const tooltipCookieExists = getTooltipAnimationCookie();

    return !tooltipCookieExists && shouldShowAnimation && !isChatExist;
  });

  React.useEffect(() => {
    const tooltipCookieExists = getTooltipAnimationCookie();
    // istanbul ignore if
    if (tooltipCookieExists) {
      setIsTooltipAnimationVisible(false);
    } else {
      setIsTooltipAnimationVisible(shouldShowAnimation && !isChatExist);
    }
  }, [shouldShowAnimation, isChatExist]);

  // istanbul ignore next
  const handleAnimationStarted = React.useCallback(() => {
    onAnimationShown({ label: trackingCustomLabel });

    // Пересчитываем значение на основе текущих условий, а не используем значение из замыкания
    const tooltipCookieExists = getTooltipAnimationCookie();
    const shouldShowTooltip = !tooltipCookieExists && shouldShowAnimation && !isChatExist;

    if (shouldShowTooltip) {
      onAnimationTooltipShown({ label: trackingCustomLabel });
    }

    setTooltipAnimationCookie();
    setTimeout(incrementAnimationShownCounter, 7000);
  }, [trackingCustomLabel, shouldShowAnimation, isChatExist, incrementAnimationShownCounter]);

  return (
    <CianChatButtonWithAnimation
      isLoading={isLoading}
      isButtonAnimationVisible={shouldShowAnimation}
      isTooltipAnimationVisible={isTooltipAnimationVisible}
      onClick={onClick}
      animationDelayMs={animationDelayMs}
      onAnimationStarted={handleAnimationStarted}
    />
  );
};
